import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import DropdownActivator from 'scaleflow/utils/dropdown-activate';

export default class InitiativesTablePmSelectorComponent extends DropdownActivator {
  @tracked personFormIsVisible = false;
  selectedInitiative = null;

  get initiative() {
    return this.args.initiative;
  }

  @action
  handleUserClick(initiative, e) {
    if (e.id === 'clear') initiative.productManager = null;
    else initiative.productManager = e;
    initiative.save();
  }

  @action
  togglePersonForm(initiative, val) {
    if (initiative) this.selectedInitiative = initiative;
    else this.selectedInitiative = null;
    if (val !== undefined) this.personFormIsVisible = val;
    else this.personFormIsVisible = !this.personFormIsVisible;
  }

  @action
  async onPersonAdded(person) {
    this.selectedInitiative.productManager = person;
    await this.selectedInitiative.save();
  }
}
